/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * 
 * @export
 * @interface PaxCheckApplyTravelDocumentResult
 */
export interface PaxCheckApplyTravelDocumentResult {
    /**
     * Whether travel document was verified, if false - travel document would require additional scan or upload to be verified
     * @type {boolean}
     * @memberof PaxCheckApplyTravelDocumentResult
     */
    successfullyVerified: boolean;
    /**
     * 
     * @type {PaxCheckPaxSession}
     * @memberof PaxCheckApplyTravelDocumentResult
     */
    updatedPaxSession: PaxCheckPaxSession;
}

/**
 * Check if a given object implements the PaxCheckApplyTravelDocumentResult interface.
 */
export function instanceOfPaxCheckApplyTravelDocumentResult(value: object): value is PaxCheckApplyTravelDocumentResult {
    if (!('successfullyVerified' in value) || value['successfullyVerified'] === undefined) return false;
    if (!('updatedPaxSession' in value) || value['updatedPaxSession'] === undefined) return false;
    return true;
}

export function PaxCheckApplyTravelDocumentResultFromJSON(json: any): PaxCheckApplyTravelDocumentResult {
    return PaxCheckApplyTravelDocumentResultFromJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyTravelDocumentResult {
    if (json == null) {
        return json;
    }
    return {
        
        'successfullyVerified': json['successfully_verified'],
        'updatedPaxSession': PaxCheckPaxSessionFromJSON(json['updated_pax_session']),
    };
}

export function PaxCheckApplyTravelDocumentResultToJSON(json: any): PaxCheckApplyTravelDocumentResult {
    return PaxCheckApplyTravelDocumentResultToJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResultToJSONTyped(value?: PaxCheckApplyTravelDocumentResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'successfully_verified': value['successfullyVerified'],
        'updated_pax_session': PaxCheckPaxSessionToJSON(value['updatedPaxSession']),
    };
}

